import { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { $get, API_URL } from './store/api';

function Kitoltok() {
  const [kitoltesek, setKitoltesek] = useState({});
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const [kitRes, tplRes] = await Promise.all([
        $get('reporting', { page }),
        $get('templates'),
      ]);
      setKitoltesek(kitRes?.data || {});
      setTemplates(tplRes?.data || []);
    })();
  }, [page]);

  const results = kitoltesek?.result || [];
  const allSelected = results.length > 0 && results.every(e => selected.includes(e.id));

  const toggleAll = () => {
    setSelected(allSelected ? [] : results.map(e => e.id));
  };

  const toggleOne = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]
    );
  };

  const download = (kitoltes, template) => {
    const ids = selected.length > 0 ? selected : [kitoltes.id];
    const token = localStorage.getItem('token') || '';
    ids.forEach(id => {
      window.open(`${API_URL}/reporting/${id}?template=${template}&token=${token}`, '_blank');
    });
  };

  const paginationItems = [];
  if (page > 1) {
    paginationItems.push(
      <Pagination.Prev key="prev" onClick={() => setPage(p => p - 1)} />
    );
  }
  paginationItems.push(
    <Pagination.Item key={page} active>{page}</Pagination.Item>
  );
  if (kitoltesek?.meta?.next_page) {
    paginationItems.push(
      <Pagination.Next key="next" onClick={() => setPage(p => p + 1)} />
    );
  }

  return (
    <div className="page-card">
      <div className="page-card-header">
        <h2>Kitöltések</h2>
        <div className="d-flex align-items-center gap-3">
          {selected.length > 0 && (
            <>
              <span className="selection-badge">
                {selected.length} kijelölve
              </span>
              <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm">
                  Letöltés ({selected.length})
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {templates.map(t => (
                    <Dropdown.Item key={t.name} onClick={() => download(null, t.name)}>
                      {t.filename}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        </div>
      </div>

      <Table className="admin-table" hover responsive>
        <thead>
          <tr>
            <th style={{ width: 44 }}>
              <Form.Check
                type="checkbox"
                checked={allSelected}
                onChange={toggleAll}
              />
            </th>
            <th>ID</th>
            <th>Név</th>
            <th>E-mail cím</th>
            <th>Dátum</th>
            <th>Letöltés</th>
          </tr>
        </thead>
        <tbody>
          {results.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center text-muted py-5">
                Nincsenek kitöltések
              </td>
            </tr>
          ) : (
            results.map(kitoltes => (
              <tr key={kitoltes.id}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selected.includes(kitoltes.id)}
                    onChange={() => toggleOne(kitoltes.id)}
                  />
                </td>
                <td className="text-muted" style={{ fontSize: 12 }}>{kitoltes.id}</td>
                <td style={{ fontWeight: 500 }}>{kitoltes.Nev}</td>
                <td>{kitoltes.Email}</td>
                <td className="text-muted" style={{ fontSize: 13 }}>
                  {kitoltes.createdAt?.replace('T', ' ')?.replace('.000Z', '')}
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="outline-secondary" size="sm" id={`dl-${kitoltes.id}`}>
                      Letölt
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {templates.map(t => (
                        <Dropdown.Item key={t.name} onClick={() => download(kitoltes, t.name)}>
                          {t.filename}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <div className="table-footer">
        <Pagination size="sm" className="mb-0">{paginationItems}</Pagination>
      </div>
    </div>
  );
}

export default Kitoltok;
